import React, { useCallback } from "react";
import { SidebarMenu } from "../../ducks/app/types";
import { IconComponent } from "./icons/types";
import styled from "styled-components";
import {
  COLOR_LIGHT_BLUE,
  COLOR_PRIMARY,
  COLOR_WHITE,
} from "../../constants/color";

type Props = {
  menu: SidebarMenu;
  selectedMenuPath: string;
  onClick: (path: string) => void;
};

export const SidebarMenuItem: React.FC<Props> = ({
  menu,
  selectedMenuPath,
  onClick,
}) => {
  const handleOnClick = useCallback((path: string) => {
    onClick(path);
  }, []);

  const _renderMenuItem = useCallback(
    (title: string, path?: string, Icon?: IconComponent, key?: string) => {
      // const isSelected = selectedMenuPath.includes(path ?? "");
      const isSelected = selectedMenuPath === path;

      return (
        <StyledSidebarMenuItemContainer
          key={key}
          $isSelected={isSelected}
          onClick={() => handleOnClick(path ?? "")}
        >
          <StyledSidebarMenuItemContent>
            {Icon && (
              <Icon fillColor={isSelected ? COLOR_PRIMARY : COLOR_WHITE} />
            )}

            <StyledSidebarMenuItemTitle $isSelected={isSelected}>
              {title}
            </StyledSidebarMenuItemTitle>
          </StyledSidebarMenuItemContent>
        </StyledSidebarMenuItemContainer>
      );
    },
    [selectedMenuPath]
  );
  return <div>{_renderMenuItem(menu.title, menu.path, menu.icon)}</div>;
};

const StyledSidebarMenuItemContainer = styled.div<{
  $isSelected: boolean;
}>`
    display: flex;
    width: 248px;
    height: 48px;
    padding: 0 10px;
    align-items: center;
    gap: 5px;
    flex-shrink: 0;
    border-radius: 8px;
    background-color: ${({ $isSelected }) =>
    $isSelected ? COLOR_LIGHT_BLUE : COLOR_PRIMARY};
    cursor: pointer;

    &:hover {
      background-color: ${COLOR_LIGHT_BLUE};
    }

    @media (max-width: 768px) {
      width: 240px;
      height: 52px;
      padding: 0 15px;
      gap: 12px;
    }
`;

const StyledSidebarMenuItemContent = styled.div`
  display: flex;
  width: 191px;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;

  @media (max-width: 768px) {
    width: 183px;
    gap: 12px;
  }
`;

const StyledSidebarMenuItemTitle = styled.div<{ $isSelected: boolean }>`
  color: ${({ $isSelected }) => ($isSelected ? COLOR_PRIMARY : COLOR_WHITE)};
  font-size: 14px;
  font-weight: 500;
  line-height: 100%;

  @media (max-width: 768px) {
    font-size: 16px;
    font-weight: 600;
  }
`;
